import { render, staticRenderFns } from "./PractitionerEdit.vue?vue&type=template&id=4adcd5d4"
import script from "./PractitionerEdit.vue?vue&type=script&lang=js"
export * from "./PractitionerEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports